import React from 'react';
import styles from './DescriptionItem.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const DescriptionItem = () => {
  return (
    <div className={styles['description-item']}>
      <div className={styles['description-header']}>
        <div className={styles['decription-tags']}>
          <div className={styles['title-tag']}>Name</div>
          <div className={styles['desc-type']}>
            <SvgWithBranding
              type='ai2'
              color='#682ECB'
              className={styles['ai-purple']}
            />
            <p className={styles['desc-type-title']}>AI</p>
          </div>
        </div>
        <div className={styles['actions']}>
          <SvgWithBranding type='edit' className={styles['edit-icon']} />
          <SvgWithBranding
            type='ai2'
            color='#011211'
            className={styles['ai-black']}
          />
        </div>
      </div>
      <p className={styles['description-text']}>
        The full name of the user as displayed in the system. This is the
        primary identifier shown in most user interfaces and reports.
      </p>
    </div>
  );
};

export default DescriptionItem;
